import { expVal } from '@confluence/feature-experiments';

import type { AgentIconType } from './agentIconType.ts';

export type AgentBrand = {
	readonly name: string;
	readonly agentIcon: AgentIconType;
};

const AGENT_BRANDS: readonly AgentBrand[] = [
	{ name: 'Claude Code', agentIcon: 'claude' },
	{ name: 'Claude', agentIcon: 'claude' },
	{ name: 'Codex', agentIcon: 'codex' },
	{ name: 'Rovo', agentIcon: 'rovo' },
	{ name: 'Cursor', agentIcon: 'cursor' },
	{ name: 'ChatGPT', agentIcon: 'chatgpt' },
	{ name: 'Dia', agentIcon: 'dia' },
];

const PRESENCE_AGENT_BRANDS: readonly AgentBrand[] = [
	{ name: '1P', agentIcon: 'first-party' },
	{ name: '1P Agent', agentIcon: 'first-party' },
	{ name: 'Amplitude', agentIcon: 'amplitude' },
	{ name: 'Antigravity', agentIcon: 'antigravity' },
	{ name: 'Canva', agentIcon: 'canva' },
	{ name: 'Cortex', agentIcon: 'cortex' },
	{ name: 'Databricks', agentIcon: 'databricks' },
	{ name: 'Figma', agentIcon: 'figma' },
	{ name: 'Gemini', agentIcon: 'gemini' },
	{ name: 'GitHub Copilot', agentIcon: 'github-copilot' },
	{ name: 'Grok', agentIcon: 'grok' },
	{ name: 'Hermes Agent', agentIcon: 'hermes' },
	{ name: 'Kiro', agentIcon: 'kiro' },
	{ name: 'Lovable', agentIcon: 'lovable' },
	{ name: 'Manus', agentIcon: 'manus' },
	{ name: 'Microsoft Copilot', agentIcon: 'microsoft-copilot' },
	{ name: 'OpenAI', agentIcon: 'openai' },
	{ name: 'Replit', agentIcon: 'replit' },
	{ name: 'Slack', agentIcon: 'slack' },
	{ name: 'Visual Studio Code', agentIcon: 'vscode' },
	{ name: 'VS Code', agentIcon: 'vscode' },
];

/**
 * The " (" separator recognizes per-integration names without matching unrelated
 * accounts. New matches are gated here because callers also use them to replace
 * account names, group activity, and decide whether profile links are available.
 */
export const getAgentBrand = (displayName: string): AgentBrand | undefined => {
	const matches = ({ name }: AgentBrand) =>
		displayName === name || displayName.startsWith(`${name} (`);
	const brand = AGENT_BRANDS.find(matches);
	if (brand) {
		return brand;
	}
	const presenceBrand = PRESENCE_AGENT_BRANDS.find(matches);
	if (presenceBrand && expVal('dual_agent_avatar_card', 'isEnabled', false)) {
		return presenceBrand;
	}
	return undefined;
};
